import { shiftDate } from '../format/dates'

/**
 * Herhaalafspraken ("elke 4 weken, 6 keer"). Elke afspraak in de reeks is een gewone, losse
 * afspraak: apart gecontroleerd op botsingen en salondagen, apart te verzetten of te annuleren.
 * Een datum die niet lukt (salon dicht, tijd bezet) wordt overgeslagen en gemeld; de rest gaat door.
 */

export const SERIES_MAX_WEEKS = 12
export const SERIES_MAX_COUNT = 26

/** De datums van een reeks, te beginnen bij `start` (die telt mee). */
export function seriesDates(start: string, everyWeeks: number, count: number): string[] {
  return Array.from({ length: count }, (_, i) => shiftDate(start, i * everyWeeks * 7))
}

/** `null` = goed. Minstens 2 keer (anders is het een gewone afspraak), hooguit een half jaar aan wekelijkse. */
export function seriesProblem(everyWeeks: number, count: number): string | null {
  if (!Number.isInteger(everyWeeks) || everyWeeks < 1 || everyWeeks > SERIES_MAX_WEEKS) return `Kies elke 1 tot ${SERIES_MAX_WEEKS} weken.`
  if (!Number.isInteger(count) || count < 2 || count > SERIES_MAX_COUNT) return `Kies 2 tot ${SERIES_MAX_COUNT} keer.`
  return null
}

/** De laatste datum van een reeks, voor "t/m di 3 mrt". */
export const seriesEnd = (start: string, everyWeeks: number, count: number) => shiftDate(start, (count - 1) * everyWeeks * 7)
